import { Period } from '@elementary/common-ui/types';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { PERIOD_PLURAL } from './constants';

const formatPeriod = (period: Period['period'], count: number): string =>
  pluralizeString(count, ...PERIOD_PLURAL[period]);

export const formatThreshold = (threshold: Period | null): string =>
  threshold ? formatPeriod(threshold.period, threshold.count) : 'None';
